import type { ReactNode } from "react";
import styles from "./SidePaneScaffold.module.css";

export type SidePaneScaffoldProps = {
  content: ReactNode;
  sidePane: ReactNode;
};
export const SidePaneScaffold = ({
  content,
  sidePane,
}: SidePaneScaffoldProps) => {
  return (
    <div className={styles["sidePaneView"]}>
      <div className={styles["mainContentArea"]}>
        <div className={styles["mainContent"]}>{content}</div>
        <div className={styles["sidePane"]}>
          <div className={styles["sidePaneContent"]}>{sidePane}</div>
        </div>
      </div>
    </div>
  );
};
